// extracted by mini-css-extract-plugin
export default {"buttons":"hfl4KO","button":"Ceq2x0","root":"QAlTCv"};